import { createApp } from 'vue';
import store from './store';
import ApiService from './api/ApiService';
import PriceManagment from '@/components/price-managment/Index.vue';
import WhatsappManagment from '@/components/whatsapp-managment/Index.vue';
import SalesManagment from '@/components/sales-managment/Index.vue';
import LogsManagment from '@/components/logs-managment/index/Index.vue';
import ShowLog from '@/components/logs-managment/show/Index.vue';
import ToolBar from '@/components/shared/ToolBar.vue';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import i18n from './locales';
import moment from 'moment';
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import { router } from './v2/router';
import { pinia } from './v2/store';
import VueSidePanel from 'vue3-side-panel';
import 'vue3-side-panel/dist/vue3-side-panel.css';
import { registerGlobalComponents } from './v2/plugins/global-components';
import { registerDirectives } from './v2/directives';
import VueHtmlToPaper from './v2/plugins/VueHtmlToPaper.js';
import AuthorizePlugin from './v2/plugins/authorize.js';

const options = {
    name: '_blank',
    specs: ['fullscreen=yes', 'titlebar=yes', 'scrollbars=yes'],
    styles: ['/bundle/css/app.css', '/bundle/css/tw.css'],
    timeout: 1000,
    autoClose: true,
    windowTitle: window.document.title,
};

const app = createApp()
	.use(pinia)
	.use(router)
	.use(store)
	.use(VueSweetalert2)
	.use(i18n)
	.use(moment)
	.use(Toast, { position: 'bottom-center', timeout: 8000 })
	.use(VueSidePanel)
	.use(VueHtmlToPaper, options)
	.use(AuthorizePlugin);

app.mixin({
	methods: {
		ApiService,
	},
});

app.component('sales-managment', SalesManagment);
app.component('price-managment', PriceManagment);
app.component('logs-managment', LogsManagment);
app.component('show-log', ShowLog);
app.component('whatsapp-managment', WhatsappManagment);
app.component('tool-bar', ToolBar);

registerGlobalComponents(app);
registerDirectives(app);

app.mount('#kt_body');
